import Exception from './exception';

export default class ExceptionInternalServerError extends Exception {
  constructor(msg: string | undefined) {
    super(msg);
    Object.setPrototypeOf(this, ExceptionInternalServerError.prototype);
  }
}